<template>
    <div id="footer">
        <v-layout>
            <v-flex xs12 class="text-xs-center">
                <div class="copyright-info">
                    <span>&copy;{{ text_RU }}</span><br>
                    <span>All Rights Reserved</span>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                text_RU: 'Май 2016 - 2019 annabratus.com',
                text_EN: 'May2016 - 2019 annabratus.com'                
            }
        }
    }
</script>


<style>
    #footer {
        background-color: #222!important;
        font-family: 'Open Sans Condensed', sans-serif;
        padding: 40px 0;
    }
</style>
